import axios from "axios";

// NOTE: Do NOT set axios.defaults.withCredentials = true globally
// This causes CORS errors for APIs that use Access-Control-Allow-Origin: *
// Only set withCredentials: true for specific requests that need it (like Odoo)

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) {
    console.log(error);
  }

  return Promise.reject(error);
});

export function setJwt(jwt) {
  axios.defaults.headers.common["authorization"] = jwt;
}
export  const http =  {
  get: axios.get,
  put: axios.put,
  post: axios.post,
  delete: axios.delete,
  setJwt
};
